import { ProfileServices } from "../../data/Services";
import CheckEmail from "../../utils/CheckEmail";
import { CheckUrl } from "../../utils/CheckUrl";

const ValidateAccountData = (key: string, value: string, currentValue?: any): Promise<boolean | string> => {
    if (key == "username") {
        return validateUserNameAsync(value, currentValue);
    } else if (key == "email" && value.length) {
        return validateEmailAsync(value, currentValue);
    } else if (key == "twitterUrl" && value.length && !(value.startsWith("https://www.twitter.com/") || value.startsWith("https://twitter.com/"))) {
        return Promise.resolve("This should be your twitter address link");
    } else if (key == "instagramUrl" && value.length && !(value.startsWith("https://www.instagram.com/") || value.startsWith("https://instagram.com/"))) {
        return Promise.resolve("This should be your Instagram address link");
    } else if (key == "websiteUrl" && value.length && !CheckUrl(value)) {
        return Promise.resolve("Website URL is not valid");
    } else if (key == "profileImgUrl" && value.length && !CheckUrl(value)) {
        return Promise.resolve("Profile Image URL is not valid");
    }
    return Promise.resolve(true);
}

const validateUserNameAsync = (username: string, currentUsername?: string): Promise<boolean | string> => {
    if (!username) return Promise.resolve("User Name is Required");
    return ProfileServices.CheckUsernameAvaliable(username).then(res => {
        if (res) {
            return res;
        } else {
            return currentUsername == username ? true : "User Name is not avaliable"
        }
    })
}

const validateEmailAsync = (email: string, currentEmail?: string): Promise<boolean | string> => {
    if (email.length && !CheckEmail(email)) return Promise.resolve("Email address is not valid");
    return ProfileServices.CheckEmailAvaliable(email).then(res => {
        if (res) {
            return res;
        } else {
            return currentEmail == email ? true : "Email address is not avaliable"
        }
    });
}

export default ValidateAccountData;